export default class WarnHandler {
  static log(msg, vm, trace) {
    let handler, current = vm
    console.log('WarnHandler | ', msg, vm, trace)
    /*if (vm.$options.warnHandler) {
      handler = vm.$options.warnHandler
    } else {
      while (current.$parent) {
        current = current.$parent
        if (handler = current.$options.warnHandler) break
      }
    }
    if (handler) {
      handler.call(current, err, vm, info)
    } else {

    }*/


  }
}



// WEBPACK FOOTER //
// ./src/plugins/WarnHandler.js